import { useState, useEffect } from 'react';
import { fetchCompetitionEvents } from '../api/api';

export function useCompetitionEvents(competition) {
  const [competitionDates, setCompetitionDates] = useState([]);

  useEffect(() => {
    console.log('useCompetitionEvents - competition changed:', competition);
    
    if(competition) {
      fetchCompetitionEvents(competition.id)
      .then(json => {
        setCompetitionDates(json.competition_events)
      })
    }
  }, [competition?.id]);

  return competitionDates;
}